module.exports = __webpack_public_path__ + "img/16_60.4749a1d4.png";